import { generateClient } from 'aws-amplify/api';
import type { Schema } from '../../amplify/data/resource';

// Single shared typed client instance
export const apiClient = generateClient<Schema>();
